import React from "react";
import EmptyProfilePicture from "../../../../../../../assets/blank-profile-picture.png";
import { ReactComponent as QuoteIcon } from "../../../../../../../assets/svg/quote-icon.svg";
import { ReactComponent as EngageIcon } from "../../../../../../../assets/svg/engage-icon.svg";
import { Icon, Popup } from "semantic-ui-react";
import { kmFormatter } from "../../../../../Dashboard//Charts/utils";

function TwitterPost(props) {
    let data = props?.data;
    // console.log(data);
    return (
        <div className="twitterPost">
            <div className="header">
                <img className="header_picture" src={props.profilePic === "" ? EmptyProfilePicture : props.profilePic} alt="empty profile icon" />
                <div className="header_name">
                    <p className="full_name">{data?.author}</p>
                    <p className="header_name_bottom">
                        <span>@{data?.user_id}</span>
                        <span>{" | "}</span>
                        <Popup trigger={<span>{data?.date}</span>} content={data?.hover_date} inverted size="tiny" />
                    </p>
                </div>
            </div>
            <div className="post">
                {data?.header !== "" && (
                    <p className="postType">
                        {data?.header} {data?.address !== "" && <span className="address">&nbsp;{data?.address}</span>}
                    </p>
                )}
                <div className="content">{data?.content}</div>
                {data?.media_type !== "text" && data.media_url && (
                    <div className="media">
                        <img src={data.media_url} />
                        {(data?.media_type === "video" || data?.media_type === "animated_gif") && (
                            <Icon name="video play" size="huge" className={"video-play"} crossOrigin="" />
                        )}
                    </div>
                )}
            </div>
            <div className="footer">
                <Popup
                    className="twitterPopup"
                    content="Replies"
                    trigger={
                        <div className="iconContainer twitterReplyIcon">
                            <Icon className="twitterIcon replyIcon" name="comment outline" size="mid" color="blue" />
                            <p className="replyTitle">{kmFormatter(data?.replies)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content="Likes"
                    trigger={
                        <div className="iconContainer twitterLikeIcon">
                            <Icon className="twitterIcon likeIcon" name="heart outline" size="mid" color="hot pink" />
                            <p className="likeTitle">{kmFormatter(data?.likes)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content="Retweets"
                    trigger={
                        <div className="iconContainer twitterRetweetIcon">
                            <Icon className="twitterIcon retweetIcon" name="retweet" size="mid" color="green" />
                            <p className="retweetTitle">{kmFormatter(data?.retweets)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />

                <Popup
                    className="twitterPopup"
                    content="Quotes"
                    trigger={
                        <div className="iconContainer twitterQuoteIcon">
                            <div className="twitterIcon quoteIcon">
                                <QuoteIcon />
                            </div>
                            <p className="quoteTitle">{kmFormatter(data?.quotes)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content="Impressions"
                    trigger={
                        <div className="iconContainer twitterImpressionIcon">
                            <Icon className="twitterIcon impressionIcon" name="eye" size="mid" color="teal" />
                            <p className="impressionTitle">{kmFormatter(data?.impressions)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content="Engagements"
                    trigger={
                        <div className="iconContainer twitterEngageIcon">
                            <div className="twitterIcon engageIcon">
                                <EngageIcon />
                            </div>
                            <p className="engagementTitle">{kmFormatter(data?.engagements)}</p>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
                <Popup
                    className="twitterPopup"
                    content="View post"
                    trigger={
                        <div className="iconContainer twitterLinkIcon">
                            <a href={data?.post_url} target="_blank" rel="noreferrer">
                                <Icon className="twitterIcon linkIcon" name="linkify" size="mid" color="#1DA1F2" />
                            </a>
                        </div>
                    }
                    size="mini"
                    position="top left"
                    inverted
                />
            </div>
        </div>
    );
}

export default TwitterPost;
